import React from "react";
import PropTypes from "prop-types";

import propTypes from "../IconCollectionDetailHero/propTypes";

import FreeUserUpsell from "./FreeUserUpsell";
import CreatorInfo from "./CreatorInfo";

import {
    CollectionTitle,
    GeneralInfo,
    Cta,
    BuyBoxLayout,
    IconInfo
} from "./styles";

const FreeUser = ({
    collectionName,
    creatorName,
    creatorCountry,
    creatorAvatarUrl,
    totalIconCount,
    creatorProfilePath,
    downloadUrl = ""
}) => {
    return (
        <BuyBoxLayout>
            <CollectionTitle>{collectionName}</CollectionTitle>
            <CreatorInfo
                creatorName={creatorName}
                creatorCountry={creatorCountry}
                creatorAvatarUrl={creatorAvatarUrl}
                creatorProfilePath={creatorProfilePath}
            />
            <GeneralInfo>
                <IconInfo>{totalIconCount} icons in PNG & SVG format</IconInfo>
            </GeneralInfo>
            <GeneralInfo>
                <FreeUserUpsell />
            </GeneralInfo>
            <Cta>Get Icon Set with Creative Pro</Cta>
        </BuyBoxLayout>
    );
};

FreeUser.propTypes = {
    ...propTypes,
    creatorProfilePath: PropTypes.string.isRequired
};

export default FreeUser;
